import React , { useEffect, useState ,Component} from "react";
import GskLoginlogo from "../assests/gsk_1.svg";
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import MailIcon from '@mui/icons-material/Mail';
import { useNavigate } from "react-router-dom";
import axiosRequest from "../api/axios";
import {config} from "../Config"
import { getUserProfile, normalizeError } from "./GetUserProfile";
import { UserAgentApplication } from 'msal';
import ErrorMessage from "./ErrorMessage";

// import Logo from "src/assests/GSK-Unveils-New-Logo.jpg"
class LoginV2 extends Component {
    // const [UserName, setUserName] = useState("");
    // const [Password, setPassword] = useState("");
    // const [opensnackbar, setopensnackbar] = React.useState(false);
    // const [content, setcontent] = React.useState('');
    // const [severity, setseverity] = React.useState('');
  //   const handleCloseSnackbar = () => {
  //     setopensnackbar(false)
  //   };
    
  //   //to set the username
  //   const handleUsername = (event) => {
  //     setUserName(event.target.value);
  //     console.log(UserName);
  //   };
  
  //   //to set the password
  //   const handlePassword = (event) => {
  //     setPassword(event.target.value);
  //     console.log(Password);
  //   };
  
  //   const GoLogin = (e) => {
        
  //     // e.preventDefault();
  //     // window.location.href="/rbmlevelbudget"
  //     axiosRequest({
  //       url: "admin_app/login",
  //       method: "POST",
  //       data: {
  //         "email": UserName,
  //       },
  //     }).then((data) => {
  //       if (data.status === 200) {
  //         console.log(data.data)
  //         localStorage.setItem("ROLE", data?.data?.user[0]?.role);
  //         localStorage.setItem("username", data?.data?.user[0]?.employee_name);
  //         setIsAuthenticated(true)
  //         if(data?.data?.user[0]?.role === 'BUH'){
  //            navigate("/rbmlevelbudget")
  //         }
  //         if(data?.data?.user[0]?.role === 'ADMIN'){
  //             navigate("/admin/head_count")
  //         }
         
  //       } else {
  //         alert('Invalid credentials')
  //         // setopensnackbar(true);
  //         // setcontent("Invalid Credentials , Please Enter the Correct Details.");
  //         // setseverity("error");
  //       }
  //     });
      
  //   };
  
  //   useEffect(() => {
  //     //   console.log(window.location.pathname,"Current Path")
  //     // if (localStorage.getItem("token")) {
  //     //    if(window.location.pathname == "/"){
  //     //     window.location.href="/dashboard"
  //     //    }
  //     // }
  // },[])

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);

    this.state = {
      isOpen: false,
      error: null,
      isAuthenticated: false,
      user: {},
      redirect: "/login"
    };

    this.userAgentApplication = new UserAgentApplication({
      auth: {
        clientId: config.appId,
        redirectUri: config.redirectUri,
        authority: config.authority
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
      }
    });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  async login() {
    // let navigate = useNavigate();
   
    try {
      await this.userAgentApplication.loginPopup(
        {
          scopes: config.scopes,
          prompt: "select_account"
        });

      const user = await getUserProfile(this.userAgentApplication, config.scopes);
     
      this.setState({
        // isAuthenticated: true,
        user: {
          displayName: user.displayName,
          email: user.mail || user.userPrincipalName,
          jobrole:user.jobTitle
        },
        error: null
      });
    
      // localStorage.setItem('username', JSON.stringify(user.displayName))
      // const login = async () => {
      await axiosRequest({
        url: "admin_app/login",
        method: "POST",
        data: {
          user: this.state.user.email
        }
      }).then((data) => {
        if (data.status == 200) {
        
          this.setState({
            isAuthenticated: true
          })
        
          localStorage.setItem("ROLE", data?.data?.user[0]?.role);
          localStorage.setItem("username", data?.data?.user[0]?.employee_name);
       
          if(data?.data?.user[0]?.role === 'BUH'){
            //  navigate("/rbmlevelbudget")
            //  setLoader(false)
          }
          if(data?.data?.user[0]?.role === 'ADMIN'){
              // navigate("/admin/head_count")
              // setLoader(false)
          }
         
        } else {
          // setLoader(false)
          alert('Invalid credentials')
        }
      });

      // };
      // axiosRequest.post("tma/login", { user })
      // .then(res => {
      //   console.log(res);
      //   console.log(res.data);
      // })

    }
    catch (err) {
      this.setState({
        isAuthenticated: false,
        user: {},
        error: normalizeError(err)
      });
    }
  }

  handleSubmit = event => {
    event.preventDefault();
  }

  logout() {
    this.UserAgentApplication.logout();
  }

  render() {
    let error = null;
    if (this.state.error) {
      error = <ErrorMessage
        message={this.state.error.message}
        debug={this.state.error.debug} />;
    }
    if (this.state.isAuthenticated == true) {
    
      // navigate("/rbmlevelbudget")
    }
  
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: "linear-gradient(to right,orangered, yellow)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="login-card"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",

        }}
      >
        <img src={GskLoginlogo} alt="" />
        {/* <input  onChange={handleUsername} type="text" placeholder="Enter your email *" className="email-field" style={{border:"1px #E5E5E5 solid",marginTop:"10px",height:"40px"}}/> */}
       <button onClick={() => this.login()} style={{width:"290px",background: "linear-gradient(to right,orangered, yellow)",border:"none",height:"35px",color:"white",borderRadius:"20px",fontWeight:"bold"}}>SIGN IN</button>
       <p style={{fontSize:"11px",fontWeight:"bold",alignSelf:"flex-end",marginRight:"85px"}}>Forgot Password</p>
      </div>
    </div>
  );
};
}
export default LoginV2;
